module.exports = __webpack_public_path__ + "img/login_text@2x.7461983a.png";